module.exports = __webpack_public_path__ + "img/5cadd68496d00ca7c35b074ba6957a5d.png";